<template>
  <div>
    <template v-if="user">
      <div
        v-if="user.complete==false"
        class="alert alert-primary"
      >Before we can review your submission we need a little bit of information about you. We need to know where you were born and where you reside. We need your contact details so that we can reach you if your work is shortlisted.</div>

      <div class="form-wrapper">
        <b-form @submit.stop="updateUser" id="user-form">
          <!-- COUNTRY OF BIRTH -->
          <div class="form-group">
            <input
              type="text"
              placeholder="Your country of birth"
              v-model="birthCountry"
              class="form-control"
              id="birthCountry"
              required
            >
          </div>
          <!-- PLACE OF BIRTH -->
          <div class="form-group">
            <input
              type="text"
              placeholder="Your place of birth"
              v-model="birthPlace"
              class="form-control"
              id="birthPlace"
              required
            >
          </div>
          <!-- COUNTRY OF RESIDENCE -->
          <div class="form-group">
            <input
              type="text"
              placeholder=" Your country of residence"
              v-model="residentCountry"
              class="form-control"
              id="residentCountry"
              required
            >
          </div>
          <!-- PLACE OF RESIDENCE -->
          <div class="form-group">
            <input
              type="text"
              placeholder=" Your place of residence"
              v-model="residentPlace"
              class="form-control"
              id="residentPlace"
              required
            >
          </div>

          <!-- ADDRESS -->
          <div class="form-group">
            <textarea
              placeholder="Enter your postal address"
              ref="address"
              v-model="address"
              class="form-control"
              id="adress"
              rows="3"
              required
            ></textarea>
          </div>
          <!-- ZIP CODE -->
          <div class="form-group">
            <input
              type="text"
              placeholder=" Your zip or postal code"
              v-model="zip"
              class="form-control"
              id="zip"
              required
            >
          </div>

          <!-- TELEPHONE NUMBER -->
          <div class="form-group">
            <input
              type="number"
              placeholder="Your telephone number"
              v-model="telephone"
              class="form-control"
              id="telephone"
              required
            >
          </div>
          <!-- WEBSITE -->
          <div class="form-group">
            <input
              type="url"
              placeholder="Your website address http://www.website.com"
              v-model="website"
              class="form-control"
              id="website"
            >
          </div>
          <!-- INSTAGRAM -->
          <div class="form-group">
            <input
              type="text"
              placeholder="Your Instagram handle"
              v-model="instagram"
              class="form-control"
              id="instagram"
            >
          </div>
          <!-- TWITTER -->
          <div class="form-group">
            <input
              type="text"
              placeholder="Your Twitter handle"
              v-model="twitter"
              class="form-control"
              id="twitter"
            >
          </div>
          <!-- DATE OF BIRTH -->
          <div class="form-group">
            <input
              type="date"
              placeholder=" Your date of birth day/month/year"
              v-model="dateOfBirth"
              class="form-control"
              id="dateOfBirth"
              required
            >
            <small
              id="date-of-birth-help-block"
              class="form-text text-muted"
            >Please enter your date of birth dd/mm/yyyy</small>
          </div>
        </b-form>
      </div>
    </template>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">Close</button>
      <b-button type="submit" variant="primary" form="user-form">Save</b-button>
    </div>
  </div>
  <!-- container -->
</template>


<script>
import { mapState } from 'vuex'
export default {
  name: 'update-user',
  components: {},
  computed: {
    ...mapState({
      user: state => state.user.user,
      entry: state => state.entry.entry
    }),
    birthCountry: {
      get() {
        return this.user.birthCountry
      },
      set(value) {
        var payload = {
          value: value,
          key: 'birthCountry'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    birthPlace: {
      get() {
        return this.user.birthPlace
      },
      set(value) {
        var payload = {
          value: value,
          key: 'birthPlace'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    residentCountry: {
      get() {
        return this.user.residentCountry
      },
      set(value) {
        var payload = {
          value: value,
          key: 'residentCountry'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    residentPlace: {
      get() {
        return this.user.residentPlace
      },
      set(value) {
        var payload = {
          value: value,
          key: 'residentPlace'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    address: {
      get() {
        return this.user.address
      },
      set(value) {
        var payload = {
          value: value,
          key: 'address'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    zip: {
      get() {
        return this.user.zip
      },
      set(value) {
        var payload = {
          value: value,
          key: 'zip'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    telephone: {
      get() {
        return this.user.telephone
      },
      set(value) {
        var payload = {
          value: value,
          key: 'telephone'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    website: {
      get() {
        return this.user.website
      },
      set(value) {
        /* split the string using '://' 
        if the array[0] == http or https do nothing 
        else append http to the string */
        var payload = {
          value: value,
          key: 'website'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    instagram: {
      get() {
        return this.user.instagram
      },
      set(value) {
        var payload = {
          value: value,
          key: 'instagram'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    twitter: {
      get() {
        return this.user.twitter
      },
      set(value) {
        var payload = {
          value: value,
          key: 'twitter'
        }
        this.$store.dispatch('user/update', payload)
      }
    },
    dateOfBirth: {
      get() {
        return this.user.dateOfBirth
      },
      set(value) {
        var payload = {
          value: value,
          key: 'dateOfBirth'
        }
        this.$store.dispatch('user/update', payload)
      }
    }
  },
  methods: {
    updateUser(e) {
      e.preventDefault()
      // console.log('here')
      this.$store
        .dispatch('user/updateUser')
        .then(() => {
          this.$root.$emit('bv::hide::modal', 'modalUser')
        })
        .catch(error => {
          const notification = {
            title: 'There is a problem updating your user profile',
            type: 'error',
            code: error.code,
            message: error.message
          }
          return this.$store.dispatch('notification/add', notification, {
            root: true
          })
        })
    },
    closeModal() {
      // console.log('here')
      this.$root.$emit('bv::hide::modal', 'modalUser')
    }
  },
  mounted() {
    this.$store.dispatch('user/fetchUser')
  }
}
</script>

<style scoped>
.modal-footer {
  margin: -1em;
  margin-top: 1em;
}
</style>
